import React, { ReactElement, ReactNode } from 'react';

export type LogoWrapperProps = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * Children displayed inside the wrapper. This particular component will display the brand logo.
   */
  children?: ReactNode;
};

/**
 * Generic container used to wrap the Logo if the consumer doesn't provide LinkProps.
 */
export const LogoWrapper = ({ children, ...rest }: LogoWrapperProps): ReactElement => <div {...rest}>{children}</div>;
